import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Wrapper = styled.nav`
  position: absolute;
  top: 15%;
  left: 40px;
  background-color: ${({ theme }) => theme.palette.colors.white};

  ul {
    display: flex;
    flex-direction: column;
    list-style-type: none;
    font-size: 1.8rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}px) {
    ul {
      font-size: 2rem;
    }
  }
`;

const MenuItem = styled.li`
  flex-grow: 1;
  flex-basis: 0;
  text-decoration: none;
  padding: 0 0 3rem 0;

  > a {
    color: ${({ active, theme }) => (theme.palette.navbar.color[active ? 'active' : 'default'])};
    display: block;
    font-weight: 600;
    text-decoration: none;
    height: 30px;
    line-height: 30px;
  }
`;

const renderMenuItemContent = (linkWrapper, label, onClick) => {
  const { elementType: ElementType, elementProps } = linkWrapper;
  return (
    <ElementType {...elementProps} onClick={onClick}>
      {label}
    </ElementType>
  );
};

const MenuNavBar = ({ items, onClick }) => (
  <Wrapper>
    <ul>
      {items.map((item) => (
        <MenuItem key={item.linkWrapper.elementProps.to} active={item.active}>
          {renderMenuItemContent(item.linkWrapper, item.label, onClick)}
        </MenuItem>
      ))}
    </ul>
  </Wrapper>
);

MenuNavBar.displayName = 'MenuNavBar';

MenuNavBar.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    active: PropTypes.bool,
    linkWrapper: PropTypes.shape({
      elementType: PropTypes.elementType.isRequired,
      elementProps: PropTypes.shape({}).isRequired,
    }).isRequired,
  })).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default MenuNavBar;
